import { render, staticRenderFns } from "./TaxCategoryForm.template.vue?vue&type=template&id=0dbcae5c&scoped=true&"
var script = {}
import style0 from "./TaxCategoryForm.template.vue?vue&type=style&index=0&id=0dbcae5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcae5c",
  null
  
)

export default component.exports